import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import './FilterMenu.css';
import filterIcon from './assets/filter-icon.svg';

function FilterMenu({ 
  filterOptions, 
  selectedFilter, 
  onFilterSelect, 
  onClearFilter,
}) {
  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <MenuButton 
            className="header-button filter-button"
          >
            <span className="button-text">
              {selectedFilter ? (
                <div className="selected-filter">
                  {selectedFilter.category}
                  {selectedFilter.subcategory && ` > ${selectedFilter.subcategory}`}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onClearFilter();
                    }}
                    className="clear-filter-button"
                  >
                    ×
                  </button>
                </div>
              ) : (
                "Filter Results"
              )}
            </span>
            
            <span className="button-icon">
              <img src={filterIcon} alt="Filter" />
            </span>
          </MenuButton>
          <MenuItems className="filter-dropdown">
            <div className="filter-dropdown-header">
              <button
                onClick={onClearFilter}
                className="clear-filters-button"
              >
                <strong>Clear Filters</strong>
              </button>
            </div>
            {filterOptions.map((categoryGroup) => (
              <div key={categoryGroup.category}>
                <MenuItem>
                  {({ focus }) => (
                    <button
                      onClick={() => onFilterSelect(categoryGroup.category)}
                      className={`filter-item ${focus ? 'focus' : ''}`}
                    >
                      <strong>{categoryGroup.category}</strong>
                    </button>
                  )}
                </MenuItem>
                {categoryGroup.subcategories.map((subcategory) => (
                  <MenuItem key={`${categoryGroup.category}-${subcategory}`}>
                    {({ focus }) => (
                      <button
                        onClick={() => onFilterSelect(categoryGroup.category, subcategory)}
                        className={`filter-item filter-sub-item ${focus ? 'focus' : ''}`}
                      >
                        {subcategory}
                      </button>
                    )}
                  </MenuItem>
                ))}
              </div>
            ))}
          </MenuItems>
        </>
      )}
    </Menu>
  );
}

export default FilterMenu;
